<ng-container *ngTemplateOutlet="contentPermissions"></ng-container>

<ng-template #contentPermissions>
    <form [formGroup]="editUserPermissionForm">
        @if (!hasPreviousUserGroup) {
            <div class="inputGroup">
                <label for="selectedGroup">{{ 'users.supplierUsers.create.groups' | translate }}</label>
                <div class="inputWrapper">
                    <app-form-error [parentForm]="editUserPermissionForm" [controlPath]="'userGroupId'" />
                    <select [ngClass]="{ noGroup: !groups?.length }" [formControlName]="'userGroupId'" id="selectedGroup">
                        @for (group of groups; track group) {
                            <option [value]="group.id" [disabled]="group.id === loggedInUserGroupId">
                                {{ group.name }}
                            </option>
                        }
                    </select>
                </div>
            </div>
            <div class="infoNotification">
                <i class="fa-solid fa-circle-info"></i>
                <span class="label">
                    {{ 'users.supplierUsers.edit.permissions.updatingPermissionsHint' | translate }}
                </span>
            </div>
        } @else {
            <div class="infoNotification">
                <i class="fa-solid fa-circle-info"></i>
                <span class="label">
                    {{ 'users.supplierUsers.edit.permissions.permissionsAlteredHint' | translate }}
                    @if (hasPreviousUserGroup) {
                        <button
                            class="button"
                            title="{{ 'users.edit.permissions.resetToGroupPermission' | translate }}"
                            type="button"
                            id="reset"
                            (click)="resetToGroupPermission()"
                        >
                            {{ 'generalKeywords.reset' | translate }}
                        </button>
                    }
                </span>
            </div>
        }
        @if (!loadingPermissions) {
            <div>
                <app-permissions-control
                    formControlName="permissions"
                    [supplierId]="data.supplierId"
                    [userId]="data.id"
                    [supplierUserOrUserGroupHasAccessToVisualsArea]="supplierUserHasAccessToVisualsArea()"
                    [visualPermissions]="visualPermissions()"
                />
            </div>
            <app-form-error class="permissionsError" [parentForm]="editUserPermissionForm" [controlPath]="'permissions'" />
        }
    </form>
</ng-template>
